module.exports = __webpack_public_path__ + "img/NR.3148eeca.png";